<script setup lang="ts">
import { useSlots } from "vue";
import type { ITransaction } from "@domain/Carbucks";
import { formatDate, currency } from "@library/Utilities";

const slots = useSlots();
defineProps<{ transactions: ITransaction[], showCashbackOnly?: boolean }>();

</script>
<template>
    <div class="uppercase pt-4 pb-2 px-4 lg:px-6 text-xs lg:text-sm 3xl:text-base grid grid-cols-5
                bg-gradient-to-b from-transparent to-gray-850">
        
            <span class="col-span-2">ITEM</span>
            <span class="col-span-3 text-right">
                <template v-if="!!slots['amountHeader']"><slot name="amountHeader"></slot></template>
                <template v-else>
                    <span>Spend / <span class="text-secondary-400">Cashback</span></span>
                </template>
            </span>
    </div>

    <div v-for="transaction in transactions"
            class="py-4 px-4 lg:px-6 
                dark:border-t border-gray-900
                3xl:text-lg
                grid grid-cols-6 items-center gap-2">
        <!-- <div class="col-span-1 rounded overflow-hidden -left-2 flex justify-center">
            <img :src="transaction.logo" class="max-h-[3rem]">
        </div> --> <!-- This is temporarily removed until we decide how we want to handle images. When re-enabling, ensure you set 'grid-cols-6' back to 'grid-cols-7' above. -->
        <div class="col-span-4">
            <div>{{ transaction.advertiserName }}</div>
            <div class="text-sm 3xl:text-base opacity-50">{{ formatDate( transaction.transactionDate, 'dddd, Do MMM YYYY' ) }}</div>
        </div>
        <div class="col-span-2 text-right text-lg 3xl:text-xl font-bold">
            <div class="tracking-wider" v-if="showCashbackOnly !== true">{{ currency( transaction.purchaseAmount ) }}</div>
            <div class="tracking-wider text-secondary-400">{{ currency( transaction.cashbackAmount ) }}</div>
        </div>
    </div>
</template>